module.exports = __webpack_public_path__ + "static/media/bursts_01.134260f3.svg";